import { DataServicePYV2 } from "./DataServicePYV2";


const MINTBOX_CLIENT_ID = "Li2L9VO1eawEbsgLrHdpZjhmUdW6N8Cm";

export default {

	get_goal_scenarios: async (data) => {
		return DataServicePYV2.post('/getGoalScenariosv1', data);
	},

	getGoalCorpus: async (data) => {
		return DataServicePYV2.post('/getGoalTargetCorpusv1', data);
	},

	getGoalSIP: async (data) => {
		return DataServicePYV2.post('/getGoalSIPv1', data);
	},

	getGoalDetails: async (data) => {
		return DataServicePYV2.post('/getGoalDetailsv1', data);
	},

	getGoalReturn: async (data) => {
		return DataServicePYV2.post('/getGoalReturnsv1', data);
	},

	getETFTrailingReturns: async (id) => {
		return DataServicePYV2.get(
			`/core/getETFTrailingReturns/${id}`
		);
	},

	getETFTrackingError: async (id) => {
		return DataServicePYV2.get(
			`/core/getETFTrackingError/${id}`
		);
	},

	updateBenchmarksNAV: async () => {
		return DataServicePYV2.post(
			`/updateBenchmarksNAV`
		);
	},

	updatePledgedData: async (data) => {
		return DataServicePYV2.post(
			`/core/updatePledgedData`, data
		);
	},

	updateFile: async (file, fileName) => {
		return DataServicePYV2.postFile(
			`/core/upload-file/fileName=` + fileName, file
		);
	},

	updateGSMData: async (data) => {
		return DataServicePYV2.post(
			`/core/updateGSMData`, data
		);
	},

	updateESMData: async (data) => {
		return DataServicePYV2.post(
			`/core/updateESMData`, data
		);
	},

	updateASMData: async (data) => {
		return DataServicePYV2.post(
			`/core/updateASMData`, data
		);
	},

	fetchSharpelyBenchmarkData: async () => {
		return DataServicePYV2.get(
			`/core/fetchSharpelyBenchmarkData`
		);
	},
	getEtfs: async () => {
		return DataServicePYV2.get(
			"/core/getAllFundsV1/instrumentType=1"
		);
	},

	getMFs: async () => {
		return DataServicePYV2.get(
			"/core/getAllFundsV1/instrumentType=0"
		);
	},
	getStocks: async () => {
		return DataServicePYV2.get(
			"/core/getAllFundsV2/instrumentType=2"
		);
	},
	getStocksColData: async (data) => {
		return DataServicePYV2.post(
			`/core/getStocksColData`, data
		);
	},
	runEOD: async () => {
		return DataServicePYV2.get(
			"/core/eod/runEOD"
		)
	},
	loadFunctionMap: async () => {
		return DataServicePYV2.get(`/core/load_function_map`)
	},
	getFunctionDoc: async ({ fileName }) => {
		return DataServicePYV2.get(`/core/getFuncDescHtml?name=${fileName}`)
	},

	get_volume_details: async () => {
		return DataServicePYV2.get(
			"/core/pipeline/eod/exchange_data_load/4"
		)
	},

	addMetricDesc: async (data) => {
		return DataServicePYV2.post(
			`/core/addMetricDesc`, data
		);
	},
	getAllKnowledgeBaseArticles: async () => {
		return DataServicePYV2.get(`/core/getAllKnowledgeBaseArticles`);
	},
	addKnowledgeBaseArticle: async (data) => {
		return DataServicePYV2.post(`/core/addKnowledgeBaseArticle`, data)
	},
	deleteKnowledgeBaseArticle: async (data) => {
		return DataServicePYV2.post(`/core/deleteKnowledgeBaseArticle`, data)
	},
	getAllClientsPortfolioConsolidated: async () => {
		return DataServicePYV2.get(`/core/getAllClientsPortfolioConsolidated`)
	},
	getAllKBArticlesV2: async () => {
		return DataServicePYV2.get(`/core/get_all_kb_articles`);
	},
	getKBArticleBySlug: async ({ slug }) => {
		return DataServicePYV2.get(`/core/get_kb_article_by_slug?article_slug=${slug}`);
	},
	upsertKBArticle: async ({ article_id, data }) => {
		const url = article_id ? `/core/upsert_kb_article?article_id=${encodeURIComponent(article_id)}` : `/core/upsert_kb_article`;
		return DataServicePYV2.post(url, data);
	}
};

